import React from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

// Components 

import TextField from '@mui/material/TextField';

const ListHeader: React.FC = () => {

  const colors = useAppSelector(state => state.theme.colors);  
  
  return (

      <Box sx={{ 
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '7.5vh',
        width: '100%',
        paddingLeft: '1%',
        backgroundColor: colors?.listHeaderBackground,
        color: colors?.text, 
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        padding: '0 1vw',
    }}>

      <>

        <div style={{  width: '18%', marginLeft: '2%' }}>User</div>

        <Box sx={{ width: '20%' }}>Email</Box>

        <Box sx={{ width: '20%' }}>Main</Box>

        <Box sx={{ width: '20%' }}>Created</Box>

      </>


  </Box>

  );

};

export default ListHeader;